var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "90%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("el-upload", {
        ref: "upload",
        staticStyle: { width: "50%" },
        attrs: {
          action: "",
          limit: 1,
          "http-request": _vm.uploadFile,
          "show-file-list": false,
        },
        scopedSlots: _vm._u([
          {
            key: "trigger",
            fn: function () {
              return [
                _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
                  _vm._v("选择上传文件"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("p", { staticStyle: { margin: "10px 0" } }, [
        _vm._v("下载导入模板: "),
        _c("span", { staticClass: "blue", on: { click: _vm.downloadFile } }, [
          _vm._v("订单模板.xlsx"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "ql-table",
          attrs: {
            data: _vm.tableData,
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold" },
            "row-key": "orderNo",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "distributorId",
              label: "分销商ID",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "distributorName",
              label: "分销商名称",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "skuId",
              label: "商品规格编码",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "num",
              label: "下单数量",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "recipientName",
              label: "收件人姓名",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "recipientPhone",
              label: "收件人手机号",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "收件人地址",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.recipientProvince) +
                        _vm._s(scope.row.recipientCity) +
                        _vm._s(scope.row.recipientArea) +
                        _vm._s(scope.row.recipientStreet) +
                        _vm._s(scope.row.recipientAddress) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "原因",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(_vm._s(scope.row.reason)),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }